<template>
	<span>
		<v-layout row v-for="(subarray, index) in characters" :key="index" class="keyboard-wrapper">
			<v-btn v-for="number in subarray" :key="number" class="number-field" @click="insertNumber(number)" :ripple="true">
				{{ number }}
			</v-btn>
			<v-btn
				v-if="index === characters.length - 1"
				@click="deleteLastDigit"
				class="delete-number"
			>
				<img :src="getImage" alt="deleteCharacter"/>
			</v-btn>
			<v-btn
				v-if="showAdditionalButtons && index === characters.length - 1"
				@click="changeCaps()"
				class="number-field"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" :fill="isUppercase ? '#ffd800' : '#FFFFFF'" viewBox="0 0 16 16">
				  <path fill-rule="evenodd" d="M7.27 1.047a1 1 0 0 1 1.46 0l6.345 6.77c.6.638.146 1.683-.73 1.683H11.5v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1H1.654C.78 9.5.326 8.455.924 7.816L7.27 1.047zM14.346 8.5 8 1.731 1.654 8.5H4.5a1 1 0 0 1 1 1v1h5v-1a1 1 0 0 1 1-1zm-9.846 5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1zm6 0h-5v1h5z"/>
				</svg>
			</v-btn>
		</v-layout>
	</span>
</template>
<script>

export default {
	name: "KeyboardInput",
	props: {
		showAdditionalButtons: Boolean,
		keyboardCharacters: {},
		getImage: {}
	},
	data() {
		return {
			items: this.keyboardCharacters,
			isUppercase: true
		};
	},
	computed: {
		characters: {
			get() {
				return this.items;
			},
			set(chars) {
				return chars;
			}
		}
	},
	methods: {
		changeCaps() {
			this.items = this.items.map(subArray => subArray.map(item => {
				if(Number.isInteger(item)) {
					return item;
				}
				if(item.toLowerCase() === item) {
					this.isUppercase = true;
					return item.toUpperCase();
				}
				this.isUppercase = false;
				return item.toLowerCase();
			})
			);
		},
		insertNumber(number) {
			this.$emit("insert-number", number);
		},
		deleteLastDigit() {
			this.$emit("delete-last-digit");
		}
	}
};
</script>
<style scoped lang="scss">
.keyboard-wrapper {
	.v-btn {
		text-transform: none;
	}
	.v-btn.number-field {
		background-color: #171618;
		border: 2px solid #1F1F20;
		color: #FFFFFF;
		height: 98px;
		flex-basis: 98px;
		font-size: 55px;
		margin: 4px;
	}
	.number-field:first-child {
		margin-left: 0;
	}
	.number-field:last-child {
		margin-right: 0;
	}

	.v-btn.delete-number {
		background-color: #171618;
		border: 2px solid #1F1F20;
		height: 98px;
		flex-basis: 203px;
		margin: 4px;
	}
}
.max-width-fix {
	max-width: 309px;
}
.description {
	font-size: 20px;
	line-height: 20px;
	margin-top: 60px;
}
.number-field.close-btn i {
	font-size: 40px;
}
</style>
